import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import ServiceCategory from '../../components/ServiceCategory';
import TechnicianCard from '../../components/TechnicianCard';
import Carousel from '../../components/Carousel';
import imgPrefix from '../../imgConfig'; // 导入 imgConfig.js
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



import axios from '../../axiosConfig';
// import { useNavigate } from 'react-router-dom';

import '../../styles/HomePage.css';
import Footer from '../../components/Footer';
import NotificationCenter from '../../components/NotificationCenter';
import { useAuth } from '../../context/AuthContext';
import { fetchAvailableTechnicians, filterStarTechnicians } from '../../utils/technicianAvailability';

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const [technicians, setTechnicians] = useState([]); // 附近技师数据
  const [starTechnicians, setStarTechnicians] = useState([]);
  const [serviceSections, setServiceSections] = useState([]); // 服务分类和对应项目

  const handleTechnicianClick = (technicianId) => {
    navigate(`/technician/${technicianId}`);
  };

  const handleServiceClick = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };
  

  // 获取在未来一小时内空闲的技师
  useEffect(() => {
    const currentLang = i18n.language || 'zh';

    const loadTechnicians = async () => {
      try {
        const available = await fetchAvailableTechnicians(currentLang);
        setTechnicians(available);
        setStarTechnicians(filterStarTechnicians(available));
      } catch (error) {
        console.error('Error fetching available technicians:', error);
        setTechnicians([]);
        setStarTechnicians([]);
      }
    };

    loadTechnicians();
  }, [i18n.language]);

  // 获取服务分类及对应项目
  useEffect(() => {
    const currentLang = i18n.language || 'zh';
    axios
      .get(`/xiangmufenlei/list?lang=${currentLang}`)
      .then((response) => {
        console.log("service",response);
        if (response.data.code === 0) {
          const categories = response.data.data.list;
          const categoryPromises = categories.map((category) =>
            axios.get(
              `/jianshenxiangmu/fenlei/${category.id}?lang=${currentLang}`
            )
          );

          // 使用 Promise.all 处理所有分类的项目请求
          Promise.all(categoryPromises)
            .then((results) => {
              console.log("xiangmu",results);
              const sections = results.map((result, index) => ({
                title: categories[index].leixing,
                items: result.data.code === 0 ? result.data.data : [],
              }));
              setServiceSections(sections);
            })
            .catch((err) =>
              console.error('Error fetching service projects:', err)
            );
        } else {
          console.error('Error fetching service categories:', response.data.msg);
        }
      })
      .catch((err) => console.error('Error fetching service categories:', err));
  }, [i18n.language]);

  const navigate = useNavigate();

  // // 点击分类跳转到对应的 ServiceList 页面
  // const handleCategoryClick = (categoryName) => {
  //   navigate(`/services/${categoryName}`);
  // };
  return (
    <div className="home-page">
      {/* 顶部 Header */}
      <NotificationCenter userId={user?.id} />
      <Header />

      <Carousel />

      <div data-v-17b88299="" class="inputxt2">
  <div data-v-17b88299="">
    <img data-v-17b88299="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAwNJREFUSEu1lU1ME1EQx/+zbSEKXgQpJLRAMDEh6gXapJ4wcEExctGgiV65+QV+QIss0lI/QNSbV0yU6AUjygUiJ0m6cFEhMZFAW5IKghdFQ0t3zC67uJTSAoZeXnfem/d7897Mfwi7/KOt7C+6CvfH4iY3mM+r64meW0xxnzg6+yOdf0qAWFlpXvk11cBE7QByEjZbJOY2c3bpU3FkZGUz0KYAj8NezUAPgMOa8zCb6IYaQJzvA6jS7J8JuOqVQkPJIBsAnnJbKUjoYuI6zWFKJm7yB8L9xg2anbY6gakLQKkKZeoHy03e8fCUcd0aQBQhrAzYW5nQDCAToJ8Ad1pzM3ouDX5dTna6JzUHM+cWolcBagF4H4BlYvjNtaEOUYSsgnVHt6OoCeAHgDrRa4HQ3CbNzHkcRS7LUtaYODkZNULEsrKMWNZShVcKjrY7iq0xyH4AFwEIAF33SUElOiPAPgGgDISzvkDolTLZUmGrJ6IXDAznmuVT10Zn/yj2h67CPQsrwhsCqpj5XOdYuE+xu532M2C8JGDCK4XUtzNEYP8GwGqBUCBKM8p/uI+VFCEWHwVQoEMUu745gAgsJpfvw3RQsYuO4vwY5AiAOZ8Uyk8LUBZ4KkoOMcXf6xDNScmgCLHpuHds+ot+ddsGtJYXHmHB9IzBeQog4aEjBJonOX6hY3z2044iaHEWnSTmgVTVykS1nYHg2x0BGCCP01YPpgMa5LE2XlZH4u/eQLiPAN4RQM+ilBEYsmjbb6BlUTdAe1chXLM60qD2/RsWU+N/ZZHx9G6HXb0KnxRKqmHpIthQaIlXkw6QptD+SQUDvRkQmvWC00Fuh10VMp8UUgXOmP9RyH5KJRWq2L2z32bGLV3siNiXl5PxSBe7pqPWLGXTro9zS8qoiN38YvQKM7nXxI5w13widGeD2OmnUeSaibpBOK3ZtiTXYLwm5sZN5TrxvpM0nCE20U01h+J8D0C15rO9hrPubtWWOd3AxJu0TGozZ5fsrGWuA+1W009VwVud+wvdQawonZRkhQAAAABJRU5ErkJggg==" />
    <span data-v-17b88299="">{t('home.guarantees.lateCompensation')}</span>
  </div>
  <div data-v-17b88299="">
    <img data-v-17b88299="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAA19JREFUSEu1lltoXFUUhr+152YuIKioCTNnaIoXgig1OSlCQxGEPjfxQXzSNy9UqEpjMlMYIaexRa1YFH2yT/FBo1ZQEOyDVJDmJCi19KHQ2k6mwSqFWjJJpzNzluyTTDmJkxlFcp7OZe//X+v/11r7CP/iKvT3J292LaVjAb12ed2weEe5u1Q4d+5Wu+3SYoGMu+m9BvMsyh6E7nVrlSWE7wKC6Sm/9CWgzbCaEowPpHfGjDmm4NpNCirwG8piCCL0KmwTexc+4teDYN/UfOn0RpJ/EEy4medE5SOElKIlI3LkVlVnjvy8sAq+dh3YkelNJmQ0UD0gSBqloqIvHPIXjkfXrSMIwZFPwqhFjq7E6rmjP5VWWum8/4l0R0c95onq/tVs9fkoyW0CK4sR84ONHPRlz1/4MApsjb6eXO5875dL15sR5tzMSyAf2EwCDXY35GoQSN51TlvNbeSHZi+/GgV5/dH77k0lU98jZMtVk92MZGIo+67NxHoy6Rd3hkJYoLybHlHMjNV8Ja4PRmUJwVOpk8AjKL8mlrsHNyvPUK6anLeeBASjU37pi5Ag5zqfA6MivDI5WzzWiD63Y1uWeP1boH+tDKeBa6A3CORMgto3hfnF5Wi2+SFnnyrvAzOeX3xarLbVzqVrKnTVapqOVsvEkDMmylubm6x/ouZFb+7yTLS64nEpiVJOLHffLW+4Tl8MLgAXPb+4PQo2NtB3Z8xUTwiyG7Qm8LFiJeB+hT3A4ygB6Ig3t3DiduauY/H66rBdcgPOLgynUH705orDG6O1unbWzNfAU8CVSqXy0NtnrpZtf+XdzJuKHAQueH7xgUY35wadUwi7CBhuS2AJQ5Kq+Qzh4Uql8tgaAQUwVde5CtyTwPQU/Eu/h55GCVpJ1KrB7DcrYdzUbId3lKvmrkb55qIStTK5FcHYQK8Tk/hxEZ4ETnp+0UqIHSHrTG5dpj1Z4ol3QDvXk0nPWukmgT8CqQ9PzV45H/bUxjK1L8fd9Ihp0mgTg5lnROTT5ploTUW+qtdrrx2eXyw2vGraaKsV0XRUSM7NDKtqV5REMTcCjZ89PH/xr+j7TUdFmEWbYdfO8HbDLty/peO6EeGWHjgNki09MiNaS95N79U2h74QTE/+10N/o6H/57flb61Q68a4OwxDAAAAAElFTkSuQmCC" />
    <span data-v-17b88299="">{t('home.guarantees.unsatisfiedRedo')}</span>
  </div>
  <div data-v-17b88299="">
    <img data-v-17b88299="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAjhJREFUSEu9lc9rE1EQx7+zthuswVMwIGZXUCvEg5cs/gHiIV6USnuoR0UExV9IkSTYVTaCFlREQUSPViQY9KA9CN5NcvHQgNWC+wpCpcdYzdZmyluyYbHZuKuNe3w77/uZme8wj9Dnj/qsj54AM51WV+KNI8R8lIEMiLa7CTF/JaDGRC8HG/FXZr3uBCUaCCgY+giDbwHY9Ycq5wk0YVXtcre4dQDThLLyOnUToMvtC7NgPFYIb5vqspBnMWdIazEOgXASwD55RoSpgcPiimmi5QetA+SN1FRb3CGFLn3U7IelEla7ZTc6ik17hX6aW3wbgCohVkVMBALabXkBwCGirFWx34UZgpyhHSTgjQsBHfO3q1OBa+iWRl32nBQ6a723H4QR92IKB/Qz3OL7AOYHv8fTnvEdQM7Qxgh4DmB2bqfYH9SWIKhs1/AX7YPrCWGsWBEl15tOBkbqKYPGwbhYrIm7UbL3YvMZ7QIIdwg8bVUXjncA97K7Y4tLjg0gSeDytkRs/NzM52YUiNT4ttScZtAIgMVkQtWlhltBLqNNEsH0BJlh3qiJa1EAQRouIG9ocwD2+AQ/FatiOAogSMMDLAPY7BP8UayKoYiArhr/p4K+e9CeoicA5ASUkwn1RNQpKhjaeQbkeMtd9MzT2JD3INSqiGKoFxt52fWCXM3o2V/Ej9wYhSZplbf+1boOguQMbYGAHV3+R3twQgEIP4m5/E9P5u8gf4sGmE5dr9kzYXzbkCnqBVoD53YGKDLjoPsAAAAASUVORK5CYII=" />
    <span data-v-17b88299="">{t('home.guarantees.customerService')}</span>
  </div>
  <div data-v-17b88299="">
    <img data-v-17b88299="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAwxJREFUSEu1lk9oVHcQxz/z3Oe/KILHmN2NCQgVoX/i2xhM8NCD3oqNBxGk7UW01aIXLdksXZp9QbwYjIrFgyLYk6kXRY/+idrui3rLQWrTfQl6ECpIVqm7eSO/5ybsbrLJSs3vtuzMfGe+M/OdJ9Tx0hs3LqVhsqlg0WjM7YBn5FdNpEdH3y7kLrUMFCTlxHcqugfYATRU2eaBm4L81uflrgroXLHmBEi1NberFQwqOCUn4zyG8Cz8rWEl64HQX8CTwDrU9/CfP6tBZgGknOi3AXIOWCYwgXAiYutQ+t74++Cll94abSwWpBvlqEIT8J+F7u/zxi+W21UAlIJfKBkMvI4EPScfTLyZj+cjHU0rVhatfuCwsbPQ78pBZgAMLYEV3DaZg/7geuNnF2pg+f9JJ/o9yJmwksDaNk1XCGAa2uvEssBmYMD1/CMfEnzaNunETpYqGcl4fsI0PgTodeJfKzpkOM9Hgg0L0VIOnkqs/1QJXmWyuTFDV0PRemJ6Ikh3xsv9HgIkndgVoFuEHzNZf7De7HsSzdtFg2sgf7le7pMw2UTskCqngCHX83eJWaJCw+S/wEq7qE3px5XTUgusx2n+TNA7oKuBX1zP/9nYpj+PNhYiMgG8tvOr1kraibUU4Cnwt+v5rfVkn3Rao0jhAco64HLG8/eWL1rSiZl4LTa0SrI91knAXYRhN+t3zTQsEd0P0i8B+zIjvqEwfMfaWtZErOIwsAn0lp1fvb1aMpKJ2F2UTiy65gGIH0R1EGFKlAMZzz//a1ub7VsvbgBfAqNTy+g8Puy/rK66AmA+inoT8aSqZkI5EH5SxTTyG+A59pIO9/5Ybi5KKyhaqMm9TvMBJTgdLmmIxKRasq3/j9yjuYIbCSm8LWtyPWOa2hzdPSVyKQQR+ao/m7teaxhmjWm9i9azJf6FTLHc9XL3awWvuWgfWyqMfPd5fvuMVJiMFlXspkteVLmuAqk8OAUdqpYQIwlF+wMPzgzI+9tgRtPIt3nznkxgxAqsg3WdzGmQRT361WP4fz5b3gH48pne4dh1owAAAABJRU5ErkJggg==" />
    <span data-v-17b88299="">{t('home.guarantees.fullProtection')}</span>
  </div>
</div>

      {/* 服务分类区域 */}
      <div className="categories">
      <ServiceCategory 
      // onCategoryClick={handleCategoryClick} 
      />
      </div>

      {/* 附近技师展示 */}
      <div className="technicians">
        <h2 style={{marginLeft:'10px'}}>{t('home.nearbyTechnicians')}</h2>
        {technicians.length > 0 ? (
          <div className="technician-list">
            {technicians.map((technician) => (
              <TechnicianCard
                key={technician.id || technician.jiaolianbianhao}
                distance={`Lv.${technician.jiaoliandengji || '-'}`}
                name={technician.jiaolianxingming}
                image={technician.jiaoliantupian}
                onClick={() => handleTechnicianClick(technician.jiaolianbianhao)}
              />
            ))}
          </div>
        ) : (
          <div className="no-technicians-message">
            {t('home.noAvailableTechnicians')}
          </div>
        )}
      </div>

      {starTechnicians.length > 0 && (
        <div className="technicians star-technicians">
          <h2 style={{marginLeft:'10px'}}>{t('home.starTechnicians')}</h2>
          <div className="technician-list">
            {starTechnicians.map((technician) => (
              <TechnicianCard
                key={`star-${technician.id || technician.jiaolianbianhao}`}
                distance={`Lv.${technician.jiaoliandengji || '-'}`}
                name={technician.jiaolianxingming}
                image={technician.jiaoliantupian}
                onClick={() => handleTechnicianClick(technician.jiaolianbianhao)}
                isSelected
              />
            ))}
          </div>
        </div>
      )}

      {/* 服务项目区域 */}
      {/* <div className="services">
        <div className="service-section">
          <h2>上门按摩</h2>
          <ServiceItem title="全身推拿" price="218元/次" />
          <ServiceItem title="中式推拿" price="168元/次" />
          <ServiceItem title="芳香SPA" price="268元/次" />
        </div>
        <div className="service-section">
          <h2>上门维修</h2>
          <ServiceItem title="管道疏通" price="138元/次" />
          <ServiceItem title="家电维修" price="30元/次" />
          <ServiceItem title="空调加氟" price="158元/次" />
        </div>
      </div> */}

      
      <div className="services">
        {serviceSections.map((section, index) => {
          console.log("serviceSections",serviceSections);
          
          return (<div key={index} className="service-section" >
            <h2>{section.title}</h2>
            <div className="service-items">
              {section.items.map((item) => (
                <div key={item.id} className="service-item" onClick={() => handleServiceClick(item.id)}>
                  <img
                    src={`${imgPrefix}/${item.xiangmutupian}`}
                    alt={item.name}
                    className="service-image"
                  />
                  <div className="service-info">
                    <h4>{item.xiangmumingcheng}</h4>
                    {/* <p>时长：{item.durationMinutes}</p> */}
                    
                  </div>
                  <span className="price">{t('home.price')}：{item.jiage}</span>
                </div>
              ))}
            </div>
          </div>)
})}
      </div>

      {/* 底部导航 */}
      {/* <footer className="footer">
        <nav>
          <a href="#home">到位</a>
          <a href="#technicians">技师</a>
          <a href="#orders">订单</a>
          <a href="#account">我的</a>
        </nav>
      </footer> */}
      <Footer />
    </div>
  );
};

export default HomePage;
